module.exports = __webpack_public_path__ + "img/home_new_0.893efb84.jpg";